var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDribble({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.176,
    height: 34.518,
    viewBox: "0 0 34.176 34.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1068",
    "data-name": "Grupo 1068",
    transform: "translate(-2666.877 7140.36)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_334",
    "data-name": "L\\xEDnea 334",
    y1: 16.817,
    x2: 16.81,
    transform: "translate(2668.291 -7137.37)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_335",
    "data-name": "L\\xEDnea 335",
    x1: 16.81,
    y2: 16.817,
    transform: "translate(2680.599 -7125.066)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7308",
    "data-name": "Trazado 7308",
    d: "M2673.063-7124.824a6.747,6.747,0,0,1-2.68-1.646,6.763,6.763,0,0,1,0-9.564,6.763,6.763,0,0,1,9.564,0,6.732,6.732,0,0,1,1.7,2.844",
    transform: "translate(-0.054 -0.448)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_336",
    "data-name": "L\\xEDnea 336",
    y2: 5.93,
    transform: "translate(2700.053 -7124.529)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_337",
    "data-name": "L\\xEDnea 337",
    y2: 2.965,
    transform: "translate(2700.053 -7115.322)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_338",
    "data-name": "L\\xEDnea 338",
    y2: 2.965,
    transform: "translate(2700.053 -7109.808)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_126",
    "data-name": "Elipse 126",
    cx: 2.757,
    cy: 8.754,
    rx: 2.757,
    ry: 8.754,
    transform: "translate(2682.649 -7134.924) rotate(-46.837)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7309",
    "data-name": "Trazado 7309",
    d: "M2681.406-7092.38c-1.042,1.111-4.745-.67-8.271-3.978s-5.54-6.888-4.5-8",
    transform: "translate(-0.034 -16.668)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribble);
export default __webpack_public_path__ + "static/media/dribble.1ddeccd6.svg";
export { ForwardRef as ReactComponent };